// extracted by mini-css-extract-plugin
export default {"title":"style_title__4oaZd","arrow":"style_arrow__no1vt"};